import { getUserBusinesses } from '../../../data/repositories/businessRepository.js';

export const fetchUserBusinesses = (page, take) => getUserBusinesses(page, take);
